export default __webpack_public_path__ + "static/media/landingHomeGrowth.e18fadc5.gif";